import headerScroll from '../partials/header';
import partnersSlider from '../partials/partners-slider'

export default {
  init() {
    window.onscroll = headerScroll;
    partnersSlider();
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/referencesPage.js